import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft, Headphones, BookOpen, Sparkles, HelpCircle } from 'lucide-react';

export const AdminContents = () => {
  const navigate = useNavigate();

  const sections = [
    {
      title: 'Thèmes Audio',
      description: '11 thèmes du programme',
      icon: Headphones,
      path: '/admin/contents/themes',
      color: 'bg-sage-500'
    },
    {
      title: 'Chapitres Méthode',
      description: '10 chapitres explicatifs',
      icon: BookOpen,
      path: '/admin/contents/chapters',
      color: 'bg-sage-600'
    },
    {
      title: 'Outils',
      description: '8 outils pratiques',
      icon: Sparkles,
      path: '/admin/contents/tools',
      color: 'bg-sage-600'
    },
    {
      title: 'Page Aide',
      description: 'Règles + Légal',
      icon: HelpCircle,
      path: '/admin/contents/help',
      color: 'bg-sage-500'
    }
  ];

  return (
    <div className="min-h-screen pb-24 bg-sand-50" data-testid="admin-contents-page">
      {/* Header */}
      <div className="bg-sage-500 px-6 py-8 text-white">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => navigate('/admin')}
          className="text-white hover:bg-sage-600 mb-4"
        >
          <ArrowLeft className="w-5 h-5" />
        </Button>
        <h1 className="text-4xl font-serif font-light mb-2">Gestion des Contenus</h1>
        <p className="text-white/80 font-sans">Modifier les thèmes, chapitres, outils et aide</p>
      </div>

      {/* Sections */}
      <div className="px-6 py-6 space-y-4">
        {sections.map((section) => {
          const Icon = section.icon;
          return (
            <Button
              key={section.path}
              onClick={() => navigate(section.path)}
              className="w-full h-auto p-6 bg-white hover:bg-sand-50 border-2 border-sand-200 hover:border-sage-500 flex items-center justify-between text-left transition-all"
              variant="outline"
            >
              <div className="flex items-center space-x-4">
                <div className={`w-12 h-12 ${section.color} rounded-xl flex items-center justify-center`}>
                  <Icon className="w-6 h-6 text-white" strokeWidth={1.5} />
                </div>
                <div>
                  <h3 className="font-sans font-semibold text-sage-700 text-lg">{section.title}</h3>
                  <p className="text-sm text-sage-700/60 font-sans mt-1">{section.description}</p>
                </div>
              </div>
              <ArrowLeft className="w-5 h-5 text-sage-700/40 rotate-180" />
            </Button>
          );
        })}
      </div>

      {/* Info */}
      <div className="px-6 py-4">
        <div className="bg-sage-50 rounded-xl p-4 border border-sage-100">
          <p className="text-sm text-sage-700 font-sans leading-relaxed">
            <strong>💡 Astuce :</strong> Utilisez le format Markdown pour mettre en forme vos textes (titres, listes, gras, italique). Une prévisualisation est disponible lors de l'édition.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminContents;